<script>
  import functions from "./shared_svelte";

  let adherents;
  let visible_adherents;
  let adherent_map, adherent_bounds, adherent_infowindow, adherent_markers;
  let attemptstoload = 0;
  functions
    .getFromAPI("adherent")
    .then((p) => {
      adherents = p;
      setUpMap();
    })
    .catch((error) => {
      console.log(error);
    });

  function setUpMap() {
    if (typeof google !== "undefined") {
      let adherent_map_container = document.getElementById(
        "adherent_map_container_svelte"
      );

      const map_options = {
        zoom: 13,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: true,
        navigationControlOptions: {
          style: google.maps.NavigationControlStyle.SMALL,
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: map_theme,
      };

      adherent_map = new google.maps.Map(adherent_map_container, map_options);
      adherent_infowindow = new google.maps.InfoWindow({ content: "..." });

      setVisibleAdherents();
    } else {
      setTimeout(() => {
        attemptstoload++;
        if (attemptstoload < 5) {
          console.log("attempts: ", attemptstoload);
          setUpMap();
        }
      }, 1500);
    }
  }

  let search_filter = {
    college: [],
    departement: [],
    keywords: "",
  };

  let colleges = [
    { name: "scenes_festivals", translation: "Scènes & Festivals" },
    { name: "artistes", translation: "Collectifs & Artistes" },
    { name: "enseignement", translation: "Enseignement & Formation" },
    { name: "edition_prod", translation: "Edition & Production" },
  ];
  let departements = [
    { name: "ain", translation: "Ain" },
    { name: "allier", translation: "Allier" },
    { name: "ardeche", translation: "Ardèche" },
    { name: "cantal", translation: "Cantal" },
    { name: "drome", translation: "Drôme" },
    { name: "isere", translation: "Isère" },
    { name: "loire", translation: "Loire" },
    { name: "haute-loire", translation: "Haute-Loire" },
    { name: "puy-de-dome", translation: "Puy-de-Dôme" },
    { name: "rhone", translation: "Rhône" },
    { name: "savoie", translation: "Savoie" },
    { name: "haute-savoie", translation: "Haute-Savoie" },
  ];

  function keywordChanged() {
    setVisibleAdherents();
  }

  function filterChanged(filter, c) {
    c = c.toString();
    if (search_filter[filter].includes(c)) {
      const index = search_filter[filter].indexOf(c);
      search_filter[filter].splice(index, 1);
    } else {
      search_filter[filter].push(c);
      search_filter[filter] = search_filter[filter];
    }
    setVisibleAdherents();
  }
  function setVisibleAdherents() {
    visible_adherents = adherents;

    const keywords = search_filter.keywords;

    if (keywords && keywords !== "") {
      // only show adherent if every keyword can be found
      const ks = functions.slugify(keywords).split(" ");

      visible_adherents = visible_adherents.filter((p) => {
        const searchString = functions.slugify(`${p.data.search_string}`);
        let isVisible = true;
        ks.forEach((keyword) => {
          if (!searchString.includes(keyword)) {
            isVisible = false;
          }
        });
        return isVisible;
      });
    }

    filterBy("college");
    filterBy("departement");

    addMarkersToMap();
  }

  function addMarkersToMap() {
    if (adherent_markers) {
      adherent_markers.forEach((m) => {
        m.setMap(null);
      });
    } else {
      adherent_markers = [];
    }

    adherent_bounds = new google.maps.LatLngBounds();

    visible_adherents.forEach((adherent) => {
      const customMarker = {
        url: "https://jazzsra.fr/wp-content/themes/jazzra_2020/images/marker.svg",
        size: new google.maps.Size(14, 20),
        origin: new google.maps.Point(0, 0),
        //	anchor: new google.maps.Point(15, 22)
        anchor: new google.maps.Point(0, 0),
      };

      const latlng = new google.maps.LatLng(
        parseFloat(adherent.data.latitude),
        parseFloat(adherent.data.longitude)
      );

      var marker = new google.maps.Marker({
        map: adherent_map,
        id: adherent.id,
        position: latlng,
        title: adherent.data.display_name,
        college: adherent.data.college,
        department: adherent.data.department,
        url: adherent.data.url,
        icon: customMarker,
      });

      marker.addListener("click", function () {
        adherent_infowindow.setContent(
          '<a class="map_link" href="' + this.url + '">' + this.title + "</a>"
        );
        adherent_infowindow.open(adherent_map, this);

        // $(".adherent_box").hide();
        // $("#adherent_box_" + this.id).show();
      });

      google.maps.event.addListener(
        adherent_infowindow,
        "closeclick",
        function () {
          // $(".adherent_box").hide();
        }
      );

      adherent_markers.push(marker);

      adherent_bounds.extend(latlng);
    });

    if (visible_adherents.length > 0) {
      adherent_map.fitBounds(adherent_bounds);
    }
  }

  function filterBy(property) {
    if (search_filter[property].length > 0) {
      //  show adherent if at least one option matches
      visible_adherents = visible_adherents.filter((p) => {
        let isVisible = false;
        search_filter[property].forEach((e) => {
          // if (p.data[property].includes(e)) {
          if (p.data[property] === e) {
            isVisible = true;
          }
        });
        return isVisible;
      });
    }
  }

  function closeAllFilters() {
    const otherfilters = document.getElementsByClassName("filter");
    for (let i = 0; i < otherfilters.length; i++) {
      otherfilters[i].classList.remove("visible");
    }
  }
  function openFilter(event) {
    const filter = event.target.parentElement;
    const open = filter.classList.contains("visible");
    closeAllFilters();
    if (!open) {
      filter.classList.toggle("visible");
    }
  }

  function handleKeydown(e) {
    const keyCode = event.keyCode;
    if (keyCode === 27) {
      // escape
      closeAllFilters();
    }
  }

  function parentClicked(e) {
    const node = e.target.nodeName;
    if (["FORM", "DIV", "SECTION", "BODY"].includes(node)) {
      closeAllFilters();
    }
  }
</script>

<svelte:window on:keydown={handleKeydown} />

<section
  data-title="Adherents Map"
  id="adherents_map"
  class="section section_adherents_map"
  on:click={(e) => parentClicked(e)}
>
  <form class="search_filters search_adherent_filters" on:submit|preventDefault>
    <div class="filter filter_adherent">
      <input
        class="text_input search_input"
        on:keyup|preventDefault={keywordChanged}
        placeholder={svtr.chercher}
        type="text"
        bind:value={search_filter.keywords}
      />
    </div>
    <div class="filter filter_adherent">
      <h3 on:click|preventDefault={(e) => openFilter(e)}>{svtr.colleges}</h3>
      <ul>
        {#each colleges as c}
          <li class:selected={search_filter.college.includes(c.name)}>
            <label>
              {c.translation}
              <input
                on:change|preventDefault={() =>
                  filterChanged("college", c.name)}
                bind:value={c.name}
                checked={search_filter.college.includes(c.name)}
                type="checkbox"
              />
            </label>
          </li>
        {/each}
      </ul>
    </div>
    <div class="filter filter_adherent">
      <h3 on:click|preventDefault={(e) => openFilter(e)}>
        {svtr.departements}
      </h3>
      <ul>
        {#each departements as c}
          <li class:selected={search_filter.departement.includes(c.name)}>
            <label>
              {c.translation}
              <input
                on:change|preventDefault={() =>
                  filterChanged("departement", c.name)}
                bind:value={c.name}
                checked={search_filter.departement.includes(c.name)}
                type="checkbox"
              />
            </label>
          </li>
        {/each}
      </ul>
    </div>
  </form>

  <div class="adherent_outer">
    <div class="adherent_boxes">
      {#if visible_adherents}
        {#each visible_adherents as adherent}
          <div class="adherent_box">
            <div class="adherent_title">
              <div class="adherent_subtitle">
                <h3>
                  <a href={adherent.data.url}>{adherent.data.display_name}</a>
                </h3>
                <p class="adherent_college">
                  <em>{adherent.data.college_tr}</em>
                </p>
              </div>
            </div>
            <!-- <h4>{adherent.data.college}</h4> -->
            <div class="description">
              <p>
                {@html adherent.data.description}
              </p>
            </div>
          </div>
        {/each}
      {/if}
    </div>
    <div id="adherent_map_container_svelte" class="adherent_map_container" />
  </div>
</section>
